// extracted by mini-css-extract-plugin
module.exports = {"container":"_1735fdc","big":"_16041cf","small":"_9a0c8cc"};